import {
	ROUTE_CONNECT,
	ROUTE_YEAR,
	ROUTE_COMPANY_INFORMATION,
	ROUTE_FALLBACK,
	ROUTE_LOGIN,
	ROUTE_LOGIN_EMAIL,
	ROUTE_LOGIN_RTLXL,
	ROUTE_LOGIN_LINK,
	ROUTE_LOGIN_LINK_SUCCESS,
	ROUTE_LOGIN_LINK_NOTIFICATION,
	ROUTE_LOGOUT,
	ROUTE_FORGOT_PASSWORD,
	ROUTE_FORGOT_PASSWORD_SENT,
	ROUTE_NEW_PASSWORD,
	ROUTE_NEW_PASSWORD_UPDATED,
	ROUTE_NEW_PASSWORD_INVALID,
	ROUTE_FORGOT_PASSWORD_NEW,
	ROUTE_FORGOT_PASSWORD_UPDATED,
	ROUTE_REGISTER,
	ROUTE_REGISTER_INCOMPLETE,
	ROUTE_REGISTER_NAME,
	ROUTE_REGISTER_BIRTHDATE,
	ROUTE_REGISTER_GENDER,
	ROUTE_REGISTER_EMAIL,
	ROUTE_REGISTER_PASSWORD,
	ROUTE_REGISTER_PRIVACY,
	ROUTE_REGISTER_NULL,
	ROUTE_VERIFY_EMAIL,
	ROUTE_EMAIL_VERIFIED,
	ROUTE_LINK,
	ROUTE_LINK_ALREADY_USED,
	ROUTE_LINK_EXPIRED,
	ROUTE_MESSAGES,
	ROUTE_THIRD_PARTY_COOKIES,
	ROUTE_GEO_CHECK,
	ROUTE_MESSAGES_NEW_PLATFORM,
	ROUTE_MESSAGES_ERROR_INACTIVE_USER,
	ROUTE_ERROR,
	ROUTE_TIER_OPTIONS,
} from './Routes';
import { LOGIN, TIERS, ONBOARDING_TIER_OPTIONS_META_DESCRIPTION } from './Copy';
import _ from 'lodash';

export const SECTION_ONBOARDING = 'onboarding';

const NAVIGATION_PAGES = [
	{
		route: ROUTE_REGISTER,
		section: SECTION_ONBOARDING,
	},
	{
		title: LOGIN,
		route: ROUTE_LOGIN,
		section: SECTION_ONBOARDING,
	},
	{
		route: ROUTE_MESSAGES,
		section: SECTION_ONBOARDING,
	},
	{
		route: ROUTE_FORGOT_PASSWORD,
		section: SECTION_ONBOARDING,
	},
	{
		route: ROUTE_NEW_PASSWORD,
		section: SECTION_ONBOARDING,
	},
	{
		title: TIERS,
		route: ROUTE_TIER_OPTIONS,
		canonicalUrl: ROUTE_TIER_OPTIONS,
		pageDescription: ONBOARDING_TIER_OPTIONS_META_DESCRIPTION,
	},
];

export const ONBOARDING_ROUTES = [
	ROUTE_CONNECT,
	ROUTE_YEAR,
	ROUTE_COMPANY_INFORMATION,
	ROUTE_FALLBACK,
	ROUTE_LOGIN,
	ROUTE_LOGIN_EMAIL,
	ROUTE_LOGIN_RTLXL,
	ROUTE_LOGIN_LINK,
	ROUTE_LOGIN_LINK_SUCCESS,
	ROUTE_LOGIN_LINK_NOTIFICATION,
	ROUTE_LOGOUT,
	ROUTE_FORGOT_PASSWORD,
	ROUTE_FORGOT_PASSWORD_SENT,
	ROUTE_NEW_PASSWORD,
	ROUTE_NEW_PASSWORD_UPDATED,
	ROUTE_NEW_PASSWORD_INVALID,
	ROUTE_FORGOT_PASSWORD_NEW,
	ROUTE_FORGOT_PASSWORD_UPDATED,
	ROUTE_REGISTER,
	ROUTE_REGISTER_INCOMPLETE,
	ROUTE_REGISTER_NAME,
	ROUTE_REGISTER_BIRTHDATE,
	ROUTE_REGISTER_GENDER,
	ROUTE_REGISTER_EMAIL,
	ROUTE_REGISTER_PASSWORD,
	ROUTE_REGISTER_PRIVACY,
	ROUTE_REGISTER_NULL,
	ROUTE_VERIFY_EMAIL,
	ROUTE_EMAIL_VERIFIED,
	ROUTE_LINK,
	ROUTE_LINK_ALREADY_USED,
	ROUTE_LINK_EXPIRED,
	ROUTE_MESSAGES,
	ROUTE_THIRD_PARTY_COOKIES,
	ROUTE_GEO_CHECK,
	ROUTE_MESSAGES_NEW_PLATFORM,
	ROUTE_MESSAGES_ERROR_INACTIVE_USER,
	ROUTE_ERROR,
];

export const PAGES = _.keyBy(NAVIGATION_PAGES, 'route');

/** Account/browse nav items were removed with billing cleanup; keep export for MenuSmallScreen. */
export const NAVIGATION = [];

export const ALWAYS_AVAILABLE_ROUTES = [...ONBOARDING_ROUTES, ROUTE_TIER_OPTIONS];

export const AVAILABLE_ROUTES_WITH_BAD_DEBT = [ROUTE_ERROR, ROUTE_LOGOUT];
